import { IEveryDoggyAPIServices } from '../../../../../../../../utils/services/EveryDoggyAPIServices';
import { PayPalRegisterDigitalProductRequest, PayPalСreateDigitalProductRequest } from '../../../../../../../../utils/services/EveryDoggyAPITypes';
import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';
import OneLinkParametersHelper from '../../../../../../../../utils/services/OneLinkParametersComposer';
import { EmptyObject } from '@reduxjs/toolkit';
import { OnApproveData, OnApproveActions } from '@paypal/paypal-js';
import { getInternalPDFId } from '../../../../../../../../utils/scripts/getInternalPDFId';
import getAmplitudeDeviceId from '../../../../../../../../utils/scripts/amplitudeDeviceId';

export interface IPayPalViewModel {
  getPayPalClientID: () => Promise<string>;
  processPaymentAction: (data: OnApproveData, actions: OnApproveActions) => Promise<EmptyObject>;
  processPaymentCancel: () => Promise<void>;
  processPaymentError: (error: Error) => Promise<void>;
	createOrderPaypal: (digitalProductKey: number) => Promise<any>;
}

function ComposePaypalViewModel(
	sourceURL: string,
	apiServices: IEveryDoggyAPIServices,
	errorLogger: IErrorLoggerWithUserSupport
): IPayPalViewModel {

	const oneLinkParametersHelper = OneLinkParametersHelper;

	// returns PayPal client id
	const getPayPalClientID = async () => {
		let data = await apiServices.getPaypalConfig();
		if (!data) data = await apiServices.getPaypalConfig();
		if (!data?.client_id) {
			throw new Error('PayPal config unavailable');
		}
		return data.client_id;
	};

	const createOrderPaypal = async (digitalProductKey) => {

		const dataToSend: PayPalСreateDigitalProductRequest = {
			'amplitude_device_id': getAmplitudeDeviceId(),
			'digital_product_offer_id': digitalProductKey,
			'fbclickid': oneLinkParametersHelper.getFBclickId(sourceURL),
			'fbp': oneLinkParametersHelper.getFBp(sourceURL),
			source_url: sourceURL,
			internal_id: getInternalPDFId(digitalProductKey),
		};

		return apiServices.createOrderPaypal(dataToSend)
			.then(result => {
				if(result) {
					return result;
				}
			});
	};

	const processPaymentAction = async (order, actions) => {

		const dataToSend: PayPalRegisterDigitalProductRequest = {
			'amplitude_device_id': getAmplitudeDeviceId(),
			'order_id': order.orderID,
			'fbclickid': oneLinkParametersHelper.getFBclickId(sourceURL),
			'fbp': oneLinkParametersHelper.getFBp(sourceURL),
			source_url: sourceURL,
			internal_id: null,
			// internal_id: getInternalPDFId(digitalProductKey),
		};

		return apiServices.registerPaypalOrder(dataToSend)
			.then(result => {
				if(result) {
          return {};
        }
			});
	};

	const processPaymentCancel = async () => {
		errorLogger.logMessage('paypal payment cancelled');
	};

	const processPaymentError = async (error: Error) => {
		errorLogger.logError(error);
	};

	return {
		getPayPalClientID,
		processPaymentAction,
		processPaymentCancel,
		processPaymentError,
		createOrderPaypal
	};
}

export default ComposePaypalViewModel;